<template>
  <Modal
    class="project-analysis-text-modal modal-themes-auto-generate"
    header-tag="h3"
    :ref="modalRef"
    :show="show"
    :widerFormat="true"
    @close="closeThisModal"
    style="display: flex; flex-direction: column; position: relative"
  >
    <template #header>
      <div
        style="
          position: relative;
          display: flex;
          flex-direction: row;
          width: 100%;
          justify-content: flex-end;
          margin-bottom: -1rem;
        "
      >
        <h2 style="display: flex">
          <VisibleText>Segment settings</VisibleText>
        </h2>
      </div>
    </template>
    <div
      style="
        display: flex;
        flex-direction: column;
        position: relative;
        height: 100%;
        margin-top: -1rem;
      "
    >
      <VisibleText
        >Select categories to use for segmentation. Segments reveal which groups respond differently
        to each theme.</VisibleText
      >
      <SelectQuestionsList
        style="width: 80%; margin: auto"
        :questions="categoricalQuestions"
        :selected-ids="selectedQuestionIds"
        :toEmitUpdate="true"
        @update-selected-question-ids="updateSelectedQuestionIds"
      />
    </div>

    <template #footer>
      <div class="modal-footer__options">
        <button class="create-new-analysis__confirm-select-btn" @click="confirmSelection">
          <SvgIconDecorative icon="check" class="create-new-analysis__confirm-select-btn-icon" />
          <VisibleText>Confirm segments</VisibleText>
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
// Mixins
import SvgIconDecorative from '@/components/UI/Svg/SvgIconDecorative.vue';
import Modal from '@/components/UI/Modal.vue';
import textAnalysisMixin from '../../Mixins/textAnalysisMixin.js';
import SelectQuestionsList from '@/components/Project/ProjectAnalysis/Components/SelectQuestionsList.vue';

export default {
  name: 'ThemesAutoSegment',
  components: {
    SvgIconDecorative,
    // ButtonIconOnly,
    // SvgIconMeaningful,
    Modal,
    SelectQuestionsList,
  },
  mixins: [textAnalysisMixin],
  props: {
    show: {
      default: () => false,
      type: Boolean,
    },
    textAnalysisObject: {
      default: () => {},
      type: Object,
    },
    categoricalQuestions: {
      default: () => [],
      type: Array,
    },
    existingSegments: {
      default: () => [],
      type: Array,
    },
  },
  data() {
    return {
      selectedQuestionIds: [],
    };
  },
  computed: {},
  methods: {
    updateSelectedQuestionIds(questionIds) {
      this.selectedQuestionIds = questionIds;
    },
    confirmSelection() {
      this.$emit('closeModal');
      this.$emit('createSegments', this.selectedQuestionIds);
      this.selectedQuestionIds = [];
    },
    closeThisModal() {
      this.$emit('closeModal');
    },
  },

  async mounted() {},

  watch: {
    existingSegments: {
      immediate: true,
      handler(newIds) {
        if (!newIds || newIds.length === 0) {
          this.selectedQuestionIds = [];
          return;
        }

        // existingSegments is already an array of question IDs
        this.selectedQuestionIds = [...newIds];
      },
    },

    show(val) {
      if (val) {
        // Rehydrate when modal opens
        this.selectedQuestionIds = [...this.existingSegments];
      }
    },
  },
};
</script>
